var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFollow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M418 532c156 0 284 75 294 234 0 6 0 26-25 26H149c-8 0-25-18-24-26 13-155 139-234 293-234zm1-324c72 0 130 58 130 130s-58 130-130 130c-73 0-131-58-131-130s58-130 131-130zm326 0c18 0 32 15 32 33v64l66 1c18 0 32 14 32 32s-14 32-32 32h-66v65c0 18-14 33-32 33h-1c-17 0-32-15-32-33v-65h-65c-18 0-33-14-33-32s15-32 33-32l65-1v-64c0-18 15-33 32-33h1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFollow);
export default __webpack_public_path__ + "static/media/ic_follow.74684b50bbdcec2bf3d2a15aa9e26a77.svg";
export { ForwardRef as ReactComponent };